import { get, isEqual } from 'lodash';

// product looks like { ..., assignments: { [key: string]: { ..., enabled: bool } } };
export const isAssignmentChanged = (prevProduct, newProduct) => {
  const prevAssignments = Object.values(get(prevProduct, 'assignments', {})).map(item => item.enabled);
  const newAssignments = Object.values(get(newProduct, 'assignments', {})).map(item => item.enabled);

  return !isEqual(prevAssignments, newAssignments);
};

export const isSKUChanged = (prevProduct, newProduct) => {
  const prevSku = get(prevProduct, 'sku', null);
  const newSku = get(newProduct, 'sku', null);

  return prevSku !== newSku;
};
